import { ExtendableError } from '@tunein/web-utils';

export type LoaderErrorType = 'Validation' | 'NotFound' | 'Forbidden' | 'Upstream' | 'Unknown';

export interface LoaderErrorDetails {
  type: LoaderErrorType;
  status?: number;
  retryable?: boolean;
  endpoint?: string;
  cause?: unknown;
}

export class LoaderError extends ExtendableError {
  readonly details: LoaderErrorDetails;

  constructor(details: LoaderErrorDetails) {
    super(
      details.cause instanceof Error ? (details.cause.message as string) : 'Unknown Load Error',
    );
    this.details = details;
    this.name = 'LoaderError';
  }
}

export interface TransportErrorDetails extends LoaderErrorDetails {
  endpoint: string;
}

export class TransportError extends ExtendableError {
  readonly details: TransportErrorDetails;

  constructor(details: TransportErrorDetails) {
    super(details.cause instanceof Error ? details.cause.message : 'Unknown Transport Error');
    this.details = details;
    this.name = 'TransportError';
  }
}
